import { Col, Input } from "reactstrap";
import { Featured, HighestPrices, LowestPrices, ProductShown } from "../../../../../Constant";
import { ChangeEvent } from "react";
import { useAppDispatch } from "../../../../../Redux-Toolkit/Hooks";
import { filterSortBy } from "../../../../../Redux-Toolkit/Reducers/FilterSlice";

export const Sorting = () => {
  const dispatch = useAppDispatch();

  const filterSort = (event:ChangeEvent<HTMLInputElement>) => {
    dispatch(filterSortBy(event.target.value));
  };

  return (
    <Col md="9" sm="12" className="text-sm-end">
      <span className="f-w-700 m-r-5">{ProductShown}</span>
      <div className="select2-drpdwn-product select-options d-inline-block" onChange={filterSort} >
        <Input type="select" className="form-control btn-square" name="select">
          <option value="Featured">{Featured}</option>
          <option value="LowestPrices">{LowestPrices}</option>
          <option value="HighestPrices">{HighestPrices}</option>
        </Input>
      </div>
    </Col>
  );
};